/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import React, { useState } from 'react';
import Tab from '../tab/Tab';
import { FlexBox, FlexBoxAlignItems, FlexBoxDirection, FlexBoxJustifyContent, Label, Text } from '@ui5/webcomponents-react';
import { uiFullWidth } from '../../Styling/Theme/Theme';
import { useTranslations } from '@/hooks/useTranslations';
const packageJson = require('../../../package.json');

interface Tab {
    icon: string;
    title: string;
    body?: string;
    component?: React.ComponentType<any>;
}

interface TabSideBarProps {
    tabs: Tab[];
    onTabSelect: (index: number) => void;
}
const TabSideBar: React.FC<TabSideBarProps> = ({ tabs, onTabSelect }) => {
    const { t } = useTranslations();
    const [selectedTab, setSelectedTab] = useState<number>(0);

    const handleSelectedTab = (index: number) => {
        setSelectedTab(index);
        onTabSelect(index);
    };

    return (
        <FlexBox
            direction={FlexBoxDirection.Column}
            justifyContent={FlexBoxJustifyContent.Start}
            alignItems={FlexBoxAlignItems.Start}
            className="content_tabsidebar"
        >
            {tabs?.map((tab: Tab, index: number) => (
                <Tab
                    key={tab.title}
                    index={index}
                    icon={tab.icon}
                    title={tab.title}
                    body={tab.body}
                    selectedTab={selectedTab}
                    handleSelectedTab={handleSelectedTab}
                />
            ))}
            <FlexBox alignItems="Center" justifyContent="Center" style={{ ...uiFullWidth, marginTop: 'auto', padding: 5 }}>
                <Label
                    style={{
                        marginRight: 4,
                    }}
                    showColon={true}
                >
                    {t('TAB_SIDEBAR_APP_VERSION_LABEL')}
                </Label>
                <Text>{packageJson.version}</Text>
            </FlexBox>
        </FlexBox>
    );
};

export default TabSideBar;
